exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3-Xrz8XpMpyaUL{height:100%;position:relative;z-index:0}._12CFb1p8rKvr6X{left:0;position:absolute;top:0;z-index:1}.a56lCU1pO2vNXU{position:fixed;right:4px;top:40px;z-index:2;max-width:270px}.SfJ6cPRUGPgPFd{left:0;position:absolute;top:0;z-index:3}._1cyB3mbofYLxk_{left:0;position:absolute;right:0;top:0;z-index:4}", ""]);

// exports
exports.locals = {
	"appLayer": "_3-Xrz8XpMpyaUL",
	"overlayLayer": "_12CFb1p8rKvr6X",
	"alertLayer": "a56lCU1pO2vNXU",
	"popoverLayer": "SfJ6cPRUGPgPFd",
	"tooltipLayerRef": "_1cyB3mbofYLxk_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/layer-manager/layer-manager.less
// module id = M9VO
// module chunks = 24